import { useState } from "react";
import { NavLink } from "react-router";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { cn } from "@/lib/utils";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useAuth } from "@/providers/AuthProvider";

interface MobileNavProps {
  isAuthenticated: boolean;
  onSignOut: () => void;
  onSignIn: () => void;
}

export function MobileNav({
  isAuthenticated,
  onSignOut,
  onSignIn,
}: MobileNavProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { teams } = useAuth();

  // Check if user has teams
  const hasTeams = teams && teams.length > 0;

  function renderNavLink(name: string, to: string, onClick?: () => void) {
    const linkClass = "flex w-full items-center py-2 text-lg font-semibold";

    if (onClick) {
      return (
        <Button
          variant="ghost"
          className={linkClass}
          onClick={() => {
            onClick();
            setIsOpen(false);
          }}
        >
          {name}
        </Button>
      );
    }

    return (
      <NavLink
        to={to}
        onClick={() => setIsOpen(false)}
        className={({ isActive }) => cn(linkClass, isActive && "text-primary")}
      >
        {name}
      </NavLink>
    );
  }

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden">
          <Menu className="h-6 w-6" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[300px] sm:w-[400px]">
        <div className="flex flex-col space-y-4 py-4">
          {isAuthenticated ? (
            <>
              {hasTeams && (
                <>
                  {renderNavLink("Dashboard", "/")}
                  {renderNavLink("Assessments", "/assessments")}
                  {renderNavLink("My profile", "/profile")}
                </>
              )}
              {renderNavLink("Sign out", "", onSignOut)}
            </>
          ) : (
            <>{renderNavLink("Sign in", "/")}</>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
